import { X, Check, PlusCircle } from "lucide-react";

/**
 * Modal for assigning a single placement to N selected bookings at once.
 * Extracted from `ProgramBooking.jsx` (iter 57.43).  The parent owns the
 * `selected` Set and passes down `size` + apply callback; we stay purely
 * presentational so the Undo toast in the parent still owns the snapshot.
 */
export default function BulkPlacementModal({ open, onClose, selectedSize, bulkVal, setBulkVal, projects, onApply, onCreateNew }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 bg-black/40 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-white rounded-lg shadow-2xl max-w-md w-full overflow-hidden flex flex-col" onClick={e => e.stopPropagation()} data-testid="pb-bulk-modal">
        <div className="p-4 border-b border-[color:var(--aii-border)] flex items-start justify-between gap-2">
          <div>
            <h3 className="font-display text-lg font-semibold">Assign placement</h3>
            <p className="text-xs text-[color:var(--aii-muted)]">One placement will be applied to <b>{selectedSize}</b> booking{selectedSize === 1 ? "" : "s"}.</p>
          </div>
          <button onClick={onClose} className="text-[color:var(--aii-muted)] hover:text-red-600 p-1"><X size={16}/></button>
        </div>
        <div className="p-4 space-y-3">
          <label className="block text-[11px] uppercase tracking-widest text-[color:var(--aii-muted)] font-semibold">Placement / Location
            <select value={bulkVal} onChange={e => setBulkVal(e.target.value)} className="input-aii mt-1" data-testid="pb-bulk-select">
              <option value="">— pick a placement —</option>
              {projects.map(p => (
                <option key={p.id} value={p.name}>
                  {p.name}{p.city || p.destination ? ` (${[p.city, p.destination].filter(Boolean).join(", ")})` : ""}
                </option>
              ))}
            </select>
          </label>
          <button data-testid="pb-bulk-new" onClick={onCreateNew}
                  className="text-xs text-brand font-semibold hover:underline flex items-center gap-1">
            <PlusCircle size={12}/> Create a new placement instead
          </button>
        </div>
        <div className="p-3 border-t border-[color:var(--aii-border)] flex items-center justify-end gap-2">
          <button onClick={onClose} className="px-3 py-2 text-sm border border-[color:var(--aii-border)] rounded-md hover:bg-slate-50">Cancel</button>
          <button data-testid="pb-bulk-apply" onClick={onApply} disabled={!bulkVal}
                  className="px-4 py-2 text-sm bg-brand text-white font-semibold rounded-md hover:bg-brand-dark disabled:opacity-50 flex items-center gap-1">
            <Check size={13}/> Apply to {selectedSize}
          </button>
        </div>
      </div>
    </div>
  );
}
